import { render } from "./MainPageNew.vue?vue&type=template&id=50f6bdb4&scoped=true"
import script from "./MainPageNew.vue?vue&type=script&lang=js"
export * from "./MainPageNew.vue?vue&type=script&lang=js"

import "./MainPageNew.vue?vue&type=style&index=0&id=50f6bdb4&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50f6bdb4"]])

export default __exports__